import React, { useContext, useEffect, useState } from "react";
import style from "./Chatpermission.module.css"
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase/config";
import { MdWbTwilight } from "react-icons/md";
import Everypermission from "./Everypermission";
import { Chatcontext } from "../context/Chatcontext";
import "react-toastify/dist/ReactToastify.css"
import {ToastContainer, toast} from"react-toastify"
const Chatpermission=()=>{
    const [images,setImages]=useState([]);
    const [allmessages,setAllmessages]=useState([]);
    const {chatid} = useContext(Chatcontext)
    useEffect(()=>{
       const getallmessages=async ()=>{
        const docRef = doc(db, "messages", chatid);
        const docSnap = await getDoc(docRef);
        const demo=[]
        const messagesdemo=[];
        if (docSnap.exists()) {
            docSnap.data().message.forEach((everymessage)=>{
                if(everymessage.status==="pending"){
                    demo.push(everymessage)
                }
                messagesdemo.push(everymessage);
            })
            setImages(demo)
            setAllmessages(messagesdemo)
        } else {
        console.log("No such document!");
        }
       }
       getallmessages()

    },[])
    const approved=async (id)=>{
        allmessages.forEach((mess)=>{
            if(mess.id===id){
                mess.status="approved";
            }
        })
        await updateDoc(doc(db,"messages",chatid), {
            message: allmessages
        });
        setImages(images.filter((im)=>im.id!==id));
        toast.success("تمت الموافقه علي ارسال الصوره")
    }
    const reject= async(id)=>{
        allmessages.forEach((mess)=>{
            if(mess.id===id){
                mess.status="reject";
            }
        })

        await updateDoc(doc(db,"messages",chatid), {
            message: allmessages
        });
        setImages(images.filter((im)=>im.id!==id));
        toast.success("تم رفض ارسال الصوره")
    }
    return(
        <div className={style.permissioncontainer}>
            <ToastContainer/>
            <div className={style.permissionnav}>
                <p> جميع الاذونات علي الصور المخصصه لهذا المشروع</p>
                <MdWbTwilight size={48}/>
            </div>
            <div className={style.permissions}>
                <table>
                    {images.map((img)=>{
                        return <Everypermission key={img.id} message={img} approved={approved} reject={reject}/>
                    })}
                </table>
            </div>
        </div>
    )
}
export default Chatpermission